Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart-widget');
    $wrapper.attr('data-template', '2');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null, loaded = false, openWidget = false;

    wrapper.open = function (userTriggeredOpen) {
        $('.js-widget-trigger', $wrapper).addClass('x-open');
        $('.js-widget-container', $wrapper).addClass('x-expanded');

        openWidget = false;

        if (userTriggeredOpen && model && model.IsPartiallyLoaded) {
            Vendd.Cart.ClearClientModel();
            openWidget = true;
            wrapper.loading(true);
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());
        } else {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.CartWidget));
        }
    };

    wrapper.close = function () {
        $('.js-widget-trigger', $wrapper).removeClass('x-open');
        $('.js-widget-container', $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        model = { ...model, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {};
    };

    wrapper.minimalUpdate = function () {
        if (model.CartWidgetDisplayOptions.ShowProductCount && model.ProductsCount >= 0) {
            if (model.ProductsCount > 0) {
                $('.js-widget-trigger', $wrapper).addClass('has-items');
                $('.number', $wrapper).text(model.CountAsOneInCart ? model.ProductsInCart : model.ProductsCount);
            } else if (model.ProductsCount == 0) {
                $('.js-widget-trigger', $wrapper).removeClass('has-items');
                $('.number', $wrapper).text('');
            }
        }

        if (loaded && !$('.js-widget-trigger', $wrapper).hasClass('x-open')) {
            loaded = false;
            $('.js-widget-container', $wrapper).empty();
        }
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("cartWidget_B", model);
        wrapper.bind(html);

        wrapper.initCategoryMenu();
        wrapper.loading(false);
    };

    wrapper.bind = function (html) {
        $('.js-widget-container', $wrapper).html(html);

        var $list = $('.x-cart-list', $wrapper);
        var $items = $('.cart-item', $list);

        wrapper.initCategoryMenu();

        if ($items.length > 0) {
            $wrapper.addClass('has-products');
            $('.site-wrapper-outer').addClass('hasProd');

        } else {
            $wrapper.removeClass('has-products');
            $('.site-wrapper-outer').removeClass('hasProd');
        }

        if (openWidget) wrapper.open();

        formatPrices($wrapper);

        $('.js-expand-combo', $items).click(function () {
            $(this).closest('.cart-item').siblings().find('.combo-item-wrapper.expanded').removeClass('expanded open-above').children('.combo-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');

            if ($(this).closest('.cart-item').index() >= ($items.length - 2) && $items.length > 3) {
                $(this).parent().toggleClass('open-above');
            }

            $(this).parent().toggleClass('expanded');
            $(this).toggleClass('icon-arrow-down icon-arrow-up');
        });

        if ($('.js-warning-message', $wrapper).length > 0) {
            if ($('.js-warning-message', $wrapper).data('reason') === 'DailyTradingLimitReached' || $('.js-warning-message', $wrapper).data('reason') === 'TradingRestriction') {
                $('.js-warning-message', $wrapper).addClass('visible');
            } else {
                $('.js-warning-message', $wrapper).removeClass('visible');
            }
        }
    };

    //Append Cart Widget Menu from Header 
    wrapper.initCategoryMenu = function () {

        var $cartMenu = $('.header-region .promo-categories-container');
        if ($cartMenu.length < 1)
            return;

        var $destination = $('.empty-container', $wrapper);

        if ($destination.length > 0 && $('.promo-categories-container', $destination).length < 1) {
            $cartMenu.clone().appendTo($destination);
        }

    };

    $wrapper.on('click', '.js-remove', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $item = $this.closest('.cart-item');
        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Remove(id));
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
    });

    //On click Checkout Button
    $wrapper.on('click', '.js-checkout', function (e) {
        if ($('.x-warehouse-selector-widget').trigger('checkout').hasClass('opening')) {
            e.preventDefault();
        }
    });

    //On click Cart Button
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        if (model === null) return;

        if ($(this).hasClass('x-open')) {
            $('.header-overlay').removeClass('visible');
            $('.header-region').removeClass('clean-zindex');
            $('html, body').removeClass('no-scroll');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.close();
        } else {
            if (!loaded) {
                wrapper.extendModel();
                wrapper.update();
                loaded = true;
            }
            $('html, body').addClass('no-scroll');
            if ($('.header-region').hasClass('sticky')) {
                $('.header-spacer').height(0);
                $('.header-region').removeClass('sticky');
            }
            $('.header-region').addClass('clean-zindex');
            $('.header-overlay').addClass('visible');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.loading(false);
            wrapper.open(true);
        }
    });

    //On click Close Button inside Cart Widget
    $wrapper.on('click', '.close-button', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    //On click outside Cart Widget
    $('.header-overlay').on('click', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.Cart;

        wrapper.extendModel();
        wrapper.minimalUpdate();

        if (loaded) wrapper.update();
        if ($wrapper.hasClass('x-loading')) $('.js-widget-trigger', $wrapper).trigger("click");
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, wrapper, function (envelope) {
        if (envelope.message.data.success === false) {
            model.IsAddToCartAllowed = true;
            toastr.error(model.WidgetLiterals.AddToCartAllowedText, "", {
                timeOut: 1200,
                showDuration: 400,
                hideDuration: 700
            });
        }
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, wrapper, function (envelope) {
        if (envelope.message.data.success === true) {
            toastr.warning(envelope.message.data.data.Messages[0], "", {
                timeOut: 1200,
                showDuration: 400,
                hideDuration: 700
            });
        }
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.CartWidget) {
            wrapper.close();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ProductAdded, wrapper, function (envelope) {
        var data = envelope.message.data;
        var flag = sessionStorage.getItem('noCartWarning');

        toastr.success(LhApp.Function.getText("Common:ProductAddedToCart"), "", { timeOut: 1200, showDuration: 400, hideDuration: 700 });

        if (data.responseData.Messages.length > 0) {
            data.responseData.Messages.forEach(function (message) {
                toastr.warning(message, "", { timeOut: 1200, showDuration: 400, hideDuration: 700 });
            });            
        }

        var isDisabled = data.responseData.CheckoutStatus ? data.responseData.CheckoutStatus.IsDisabled : null;
        var reason = data.responseData.CheckoutStatus ? data.responseData.CheckoutStatus.Reason : null;

        if (isDisabled && (reason === 'DailyTradingLimitReached' || reason === 'TradingRestriction') && flag === null) {
            toastr.warning(data.responseData.CheckoutStatus.ReasonText, "", { timeOut: 15000, showDuration: 400, hideDuration: 700 });
            sessionStorage.setItem('noCartWarning', true);
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, wrapper, function (envelope) {
        toastr.success(LhApp.Function.getText("Common:ProductAddedToCart"), "", { timeOut: 1200, showDuration: 400, hideDuration: 700 });
    });

    // TODO: Review
    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.OpenWidget, wrapper, function (envelope) {
        if (envelope.message.data.widgetName === Vendd.Widget.CartWidget) {
            if (envelope.message.data.immediate === true) {
                wrapper.open(true);
            } else {
                openWidget = true; // the next refresh will open it
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {

        var isB2B = envelope.message.data.model.IsB2BUser;
        var isAuthenticated = envelope.message.data.model.IsAuthenticated

        if (isB2B && isAuthenticated && venddProjectConfigs.SiteIsLocked) {
            $wrapper.removeClass('site-is-locked');
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());
        }
    });

});